// extracted by mini-css-extract-plugin
export default {"scrollable-content":"ViewBankDetails_scrollable-content__1Am7L","card":"ViewBankDetails_card__8CIsS","ant-card-head-title":"ViewBankDetails_ant-card-head-title__LJ3Rg"};